module.exports = __webpack_public_path__ + "static/img/Iron_ore@2x.5612615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/Iron_ore@2x.png
// module id = a4zi
// module chunks = 44